import is from '@sindresorhus/is';
import { Fragment, type FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import type { CustomAttribute } from '~/shared/data-contract/custom-attribute';
import { IconExternalLink } from '~/ui/core/icons';

import { EditableMetadataFields } from './EditableMetadataFields';

export const UrlSection: FunctionComponent<{
    readonly customAttributes: readonly CustomAttribute[];
    readonly isEditing: boolean;
    readonly learningLanguageCodes: readonly string[];
    readonly providerOptions: readonly string[];
    readonly url: string | undefined;
}> = ({ customAttributes, isEditing, learningLanguageCodes, providerOptions, url }) => {
    const translate = useTranslate();

    if (isEditing) {
        return (
            <EditableMetadataFields
                customAttributes={customAttributes}
                learningLanguageCodes={learningLanguageCodes}
                providerOptions={providerOptions}
            />
        );
    }

    return (
        <Fragment>
            <h3 className="m-0 text-body-m font-medium text-text-primary">
                {translate('pages.learning-opportunities.url')}
            </h3>
            {is.nonEmptyString(url) ? (
                <a
                    className="inline-flex w-fit items-center gap-xs break-all text-text-primary text-sm hover:underline"
                    href={url}
                    rel="nofollow noopener noreferrer"
                    target="_blank"
                >
                    <span>{url}</span>
                    <IconExternalLink size={14} />
                </a>
            ) : (
                <p className="m-0 text-text-content-subtle text-sm">–</p>
            )}
        </Fragment>
    );
};
